import { render } from "./FormRegisterSection3.vue?vue&type=template&id=49759a21&scoped=true"
import script from "./FormRegisterSection3.vue?vue&type=script&lang=js"
export * from "./FormRegisterSection3.vue?vue&type=script&lang=js"

import "./FormRegisterSection3.vue?vue&type=style&index=0&id=49759a21&scoped=scoped&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49759a21"]])

export default __exports__